import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import styled from "styled-components";

interface PropsType {
  children: React.ReactNode; // Define the children prop
}
const MultipleOption: React.FC<PropsType> = (props) => {
  return <Root>{props.children}</Root>;
};
export default MultipleOption;

const Root = styled.div`
  position: relative;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  padding: clamp(2rem, 5vw, 3.5rem) clamp(1.75rem, 5vw, 3rem);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Gilroy-Regular', 'Gilroy', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    border-color: #d1d5db;
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  .field_name,
  .title {
    font-family: 'Gilroy-Bold', 'Gilroy', sans-serif;
    font-size: clamp(1.75rem, 4vw, 2.25rem);
    font-weight: 700;
    color: #111827;
    margin-bottom: 1rem;
    line-height: 1.2;
    letter-spacing: -0.025em;
    background: linear-gradient(135deg, #111827 0%, #374151 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .sr_number {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 2rem;

    span {
      background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
      color: white;
      padding: 0.5rem 0.75rem;
      border-radius: 8px;
      font-size: 1rem;
      font-weight: 600;
      min-width: 2rem;
      text-align: center;
      box-shadow: 0 2px 4px -1px rgba(59, 130, 246, 0.5);
      flex-shrink: 0;
      margin-top: 0.25rem;

      @media (max-width: 768px) {
        font-size: 0.875rem;
        padding: 0.375rem 0.625rem;
        margin-top: 0.125rem;
      }
    }

    .text_danger {
      color: #ef4444;
      font-size: 1.25rem;
      font-weight: 600;
      margin-left: 0.5rem;
    }
  }

  .discription {
    font-size: 1.125rem;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 2rem;
    background: transparent;
    border: none;

    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 1.5rem;
    }
  }

  .multi_option {
    display: grid;
    gap: 1rem;
    max-width: 100%;

    @media (min-width: 640px) {
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    }

    button {
      background: white;
      border: 2px solid #e2e8f0;
      border-radius: 12px;
      padding: 1.25rem 1.5rem;
      text-align: left;
      font-size: 1.125rem;
      font-weight: 600;
      color: #1e293b;
      cursor: pointer;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      align-items: center;
      gap: 1rem;
      min-height: 4rem;
      word-break: break-word;

      &:hover {
        border-color: #3b82f6;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.1);
      }

      &.active {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        border-color: #3b82f6;
        color: white;
        box-shadow: 0 4px 8px -2px rgba(59, 130, 246, 0.5);

        span {
          background: white;
          color: #3b82f6;
        }
      }

      @media (max-width: 768px) {
        font-size: 1rem;
        padding: 1rem 1.25rem;
        min-height: 3.5rem;
      }

      span {
        background: #f1f5f9;
        color: #64748b;
        width: 2rem;
        height: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 0.875rem;
        font-weight: 700;
        flex-shrink: 0;

        @media (max-width: 768px) {
          width: 1.75rem;
          height: 1.75rem;
          font-size: 0.75rem;
        }
      }
    }
  }

  .option_box {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 1rem 0;

    span {
      font-size: 1.125rem;
      font-weight: 600;
      color: #64748b;
      min-width: 6rem;
    }
  }

  .multi_option_btn input {
    background: #f8fafc;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    color: #1e293b;
    font-family: inherit;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      background: white;
    }
  }

  .option_btn {
    color: #3b82f6;
    background: none;
    border: none;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 4px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: #f1f5f9;
    }
  }

  .delete_btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #dc2626;
    padding: 0.5rem;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    width: auto;
    height: auto;

    &:hover {
      background: #fee2e2;
      border-color: #fca5a5;
      transform: scale(1.05);
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .option_box_field {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0;
    margin: 1.25rem 0;

    input {
      flex: 1;
      border: 2px solid #e5e7eb;
      border-right: none;
      border-radius: 10px 0 0 10px;
      padding: 1rem 1.125rem 1rem 3.25rem;
      font-size: 1rem;
      color: #111827 !important;
      font-weight: 500;
      font-family: 'Gilroy-Medium', 'Gilroy', sans-serif;
      background: #ffffff !important;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      -webkit-text-fill-color: #111827 !important;

      &:hover {
        border-color: #d1d5db;
      }

      &:focus {
        outline: none;
        border-color: #3b82f6;
        background: #ffffff;
        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1), 0 2px 6px rgba(0, 0, 0, 0.08);
      }

      &::placeholder {
        color: #9ca3af;
        font-weight: 400;
      }
    }

    span {
      position: absolute;
      left: 1rem;
      top: 50%;
      transform: translateY(-50%);
      background: #f8fafc;
      color: #64748b;
      font-size: 0.875rem;
      font-weight: 600;
      padding: 0.25rem 0.5rem;
      border-radius: 4px;
      z-index: 1;
    }

    .delete_option {
      background: #fef2f2;
      border: 2px solid #e2e8f0;
      border-left: none;
      border-radius: 0 8px 8px 0;
      padding: 0.875rem;
      cursor: pointer;
      color: #ef4444;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: #fee2e2;
        border-color: #fca5a5;
      }

      img {
        width: 1rem;
        height: 1rem;
      }
    }
  }
`;
